__turbopack_context__.v({
  "text-field-box": "zrNibq_text-field-box",
  "text-field-input": "zrNibq_text-field-input",
});
